export default "__VITE_ASSET__DoZBa1Wl__"